// API URL configuration with runtime detection for staging
export const getApiUrl = () => {
    // Check if we're on staging domain
    if (typeof window !== 'undefined' && window.location.hostname === 'staging.chatwars.me') {
        return 'https://api-staging.chatwars.me/telegram/';
    }

    // Default to production or env variable
    return process.env.REACT_APP_API_URL || 'https://api.chatwars.me/webview/';
};

// Export as constant for use throughout the app
export const API_URL = getApiUrl();
